import React from "react";
import ViewForm from "../components/PortalForms/ViewForm";
import { Modal } from "react-bootstrap";

const viewFormModalStyles = `
  .rt-view-form-modal .modal-content {
    border: 1px solid #cbd5e1 !important;
    border-radius: 0 !important;
    overflow: hidden !important;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
    background: #ffffff !important;
  }

  .rt-view-form-modal .modal-dialog {
    max-width: 1140px !important;
  }

  /* ── Header ────────────────────────────────── */
  .rt-vfm-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
  }
  .rt-vfm-header-left {
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
  }
  .rt-vfm-header-icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 !important;
    background: #eff6ff;
    border: 1px solid #dbeafe;
    color: #1d4ed8;
    font-size: 16px;
    box-shadow: none !important;
  }
  .rt-vfm-header-text {
    min-width: 0;
  }
  .rt-vfm-header-title {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #0f172a !important;
    margin: 0 0 2px 0 !important;
    line-height: 1.3 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 600px;
  }
  .rt-vfm-header-subtitle {
    font-size: 12.5px !important;
    color: #64748b !important;
    margin: 0 !important;
    line-height: 1.3 !important;
  }
  .rt-vfm-close-btn {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 !important;
    border: 1px solid #cbd5e1;
    background: #ffffff;
    color: #64748b;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    outline: none;
    padding: 0;
    line-height: 1;
    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06);
  }
  .rt-vfm-close-btn:hover {
    background: #fef2f2;
    border-color: #fca5a5;
    color: #dc2626;
    transform: translateY(-1px);
  }
  .rt-vfm-close-btn:active {
    transform: translateY(0);
  }

  /* ── Body ──────────────────────────────────── */
  .rt-vfm-body {
    padding: 0 !important;
    background: #ffffff;
  }
  .rt-vfm-body-inner {
    height: 600px;
    overflow-y: auto;
    padding: 20px 24px;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
  }
  .rt-vfm-body-inner::-webkit-scrollbar {
    width: 6px;
  }
  .rt-vfm-body-inner::-webkit-scrollbar-track {
    background: transparent;
  }
  .rt-vfm-body-inner::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 0;
  }
  .rt-vfm-body-inner::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }

  /* ── Footer ────────────────────────────────── */
  .rt-vfm-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 14px 24px;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
    gap: 10px;
  }
  .rt-vfm-footer-btn {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 7px !important;
    padding: 7px 18px !important;
    border-radius: 0 !important;
    font-size: 13.5px !important;
    font-weight: 500 !important;
    cursor: pointer !important;
    transition: all 0.2s ease !important;
    outline: none !important;
    border: 1px solid #cbd5e1 !important;
    background: #ffffff !important;
    color: #1e293b !important;
    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
  }
  .rt-vfm-footer-btn:hover {
    background: #f8fafc !important;
    border-color: #94a3b8 !important;
    color: #0f172a !important;
    transform: translateY(-1px) !important;
  }
  .rt-vfm-footer-btn:active {
    transform: translateY(0) !important;
  }

  /* ── Backdrop ──────────────────────────────── */
  .rt-view-form-modal + .modal-backdrop,
  .rt-view-form-backdrop {
    background-color: rgba(15, 23, 42, 0.45) !important;
    backdrop-filter: blur(4px) !important;
  }
`;

const ViewFormModal = (props) => {
    const { handleViewForm, viewFormShowHide, workflowTask, selectedForm, refereshFormData, formName = "", maxFiles } = props;

    return (
        <React.Fragment>
            <style>{viewFormModalStyles}</style>
            <Modal show={viewFormShowHide} size="xl" dialogClassName="rt-view-form-modal" backdrop="static">
                {/* Custom Header */}
                <div className="rt-vfm-header">
                    <div className="rt-vfm-header-left">
                        <div className="rt-vfm-header-icon">
                            <i className="fa fa-file-text-o" aria-hidden="true" />
                        </div>
                        <div className="rt-vfm-header-text">
                            <h5 className="rt-vfm-header-title">
                                {formName || selectedForm?.formName || "View Form"}
                            </h5>
                            <p className="rt-vfm-header-subtitle">
                                <i className="fa fa-eye" aria-hidden="true" style={{ marginRight: "4px" }} />
                                Review and update form details
                            </p>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="rt-vfm-close-btn"
                        onClick={handleViewForm}
                        title="Close"
                    >
                        <i className="fa fa-times" aria-hidden="true" />
                    </button>
                </div>

                {/* Body */}
                <Modal.Body className="rt-vfm-body">
                    <div className="rt-vfm-body-inner">
                        <ViewForm
                            formShowHide={viewFormShowHide}
                            handleFormShowHide={viewFormShowHide}
                            workflowTask={workflowTask}
                            selectedForm={selectedForm}
                            refereshFormData={refereshFormData}
                            formName={formName || selectedForm?.formType || selectedForm?.formName || selectedForm?.title || ""}
                            maxFiles={maxFiles}
                        />
                    </div>
                </Modal.Body>

                {/* Footer */}
                <div className="rt-vfm-footer">
                    <button
                        type="button"
                        className="rt-vfm-footer-btn"
                        onClick={handleViewForm}
                    >
                        <i className="fa fa-times" aria-hidden="true" /> Close
                    </button>
                </div>
            </Modal>
        </React.Fragment>
    );
};

export default ViewFormModal;